export const manualTabTableQueryKey = "annual-vacation-statistics-manual-tab";
